import events from "_src/engine/events";
import appState from "_src/app_state";

import workspace from "_src/workspace";
import selector from "_src/manipulators/libs/selector";

export default class AbstractManipulator {

  constructor(camera) {

    this._enabled = false;

    this._onMouseDown = (coords) => {
      if (appState.getStateValue("editingAllowed")) {
        const scene = workspace.getScene();
        scene.updateTransforms();
        this._mouseDownHandler(coords);
      }
    }

    this._onMouseMove = (coords) => {
      if (appState.getStateValue("editingAllowed")) {
        this._mouseMoveHandler(coords);
      }
    }

    this._onMouseUp   = (coords) => {
      if (appState.getStateValue("editingAllowed")) {
        this._mouseUpHandler(coords);
      }
    }

    this._onControllerStart = (coords) => {
      if (appState.getStateValue("editingAllowed")) {
        this._controllerStartHandler(coords);
      }
    }

    this._onControllerStop = (coords) => {
      if (appState.getStateValue("editingAllowed")) {
        this._controllerStopHandler(coords);
      }
    }


    this._onCamMove   = (cam) => {
      this._cameraMoveHandler(cam)
    }

    this._onResize    = (widthHeight) => { this._resizeHandler(widthHeight) }

    this._onUndo = () => this._undoHandler();
    this._onRedo = () => this._redoHandler();

    this._camera = camera;

  }

  _mouseDownHandler() { }
  _mouseMoveHandler() { }
  _mouseUpHandler() { }
  _resizeHandler() { }
  _cameraMoveHandler() { }
  _undoHandler() { }
  _redoHandler() { }

  _controllerStartHandler() { }
  _controllerStopHandler() { }

  _onStart  () { }
  _onStop () { }

  setEnabled(enabled) {

    if (this._enabled === enabled) {
      return;
    }

    this._enabled = enabled;

    if (enabled) {

      this._attachEvents();
      this._onStart();

      const objects = workspace.getObjects();

      for (let i = 0; i < objects.length; ++i) {

        const object = objects[i];

        if (!workspace.checkIsReady(object)) {
          continue;
        }

        selector.dropSelection(object);
        workspace.applyState(object);

      }

    } else {
      events.emit("manipulatorDisabled");
      this._detachEvents();
      this._onStop();
    }

  }

  getEnabled() {
    return this._enabled;
  }

  _attachEvents() {

    events.on("manipulator_start", this._onMouseDown);
    events.on("manipulator_move", this._onMouseMove);
    events.on("manipulator_end",   this._onMouseUp);
    events.on("control_start", this._onControllerStart);
    events.on("control_end", this._onControllerStop);
    events.on("camera_move", this._onCamMove);
    events.on("canvas_resize", this._onResize);
    events.on("undo", this._onUndo);
    events.on("redo", this._onRedo);

  }

  _detachEvents() {

    events.off("manipulator_start", this._onMouseDown);
    events.off("manipulator_move", this._onMouseMove);
    events.off("manipulator_end",   this._onMouseUp);
    events.off("control_start", this._onControllerStart);
    events.off("control_end", this._onControllerStop);
    events.off("camera_move", this._onCamMove);
    events.off("canvas_resize", this._onResize);
    events.off("undo", this._onUndo);
    events.off("redo", this._onRedo);

  }

  cleanup() {
    this._detachEvents();
  }

}
